import { createSlice } from "@reduxjs/toolkit";
import {
  getAssets,
  addStrategies,
  getCustodians,
  Allstrategies,
  GetAccounting,
  modifyStrategies,
  getCustodianAssets,
  Strategyperformancegraph,
  AlluserStrategies,
  GetInvestors,
  modifyHurdleRate,
  GetAccountingPortfolio,
  AddAccountingFirm,
  GetAccountingFirms,
  UpdateAccountingFirm,
  DeleteAccountingFirm,
  getAllInvestorsWithStrategies
} from "../Actions/strategyService";
import customSuccessAlert from "../../Alerts/customSuccessAlert";
import customFailAlert from "../../Alerts/customFailAlert";

const initialState = {
  error: "",
  status: "",
  loading: false,
  strategies: [],
  assetlist: [],
  Assets: {},
  custodianAssets: [],
  addstrategiesData: {},
  Custodians: [],
  Accountingdata: {},
  AccountingPortfolio: {},
  AccountingPortfolioData: {},
  custodianData: [],
  userStrategies: [],
  accountingFirms: [],
  strategiesWithInvestors: [],
};
const strategyReducer = createSlice({
  name: "strategy",
  initialState,
  reducers: {},
  extraReducers: {
    [Allstrategies.pending]: (state) => {
      state.loading = true;
    },
    [Allstrategies.fulfilled]: (state, action) => {
      state.loading = false;

      const {
        status,
        data,
        message,
        statusCode,
        strategies: topLevelStrategies,
      } = action.payload || {};

      let resolvedStrategies = [];

      if (Array.isArray(topLevelStrategies)) {
        resolvedStrategies = topLevelStrategies;
      } else if (Array.isArray(data?.strategies)) {
        resolvedStrategies = data.strategies;
      } else if (Array.isArray(data?.data?.strategies)) {
        resolvedStrategies = data.data.strategies;
      } else if (Array.isArray(data)) {
        resolvedStrategies = data;
      } else if (Array.isArray(data?.data)) {
        resolvedStrategies = data.data;
      } else if (Array.isArray(action.payload)) {
        resolvedStrategies = action.payload;
      }

      if (resolvedStrategies.length > 0) {
        state.strategies = resolvedStrategies;
        state.message = message ?? null;
        state.status = status ?? null;
        state.code = statusCode ?? 200;
        state.error = null;
      } else {
        state.strategies = [];
        state.error = message ?? "Unable to fetch strategies.";
        state.status = status ?? null;
        state.code = statusCode ?? null;
      }
    },
    [Allstrategies.rejected]: (state) => {
      state.loading = false;
    },

    [GetInvestors.pending]: (state) => {
      state.loading = true;
    },
    [GetInvestors.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.InvestorsData = data;
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.InvestorsData = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [GetInvestors.rejected]: (state) => {
      state.loading = false;
    },

    [modifyHurdleRate.pending]: (state) => {
      state.loading = true;
    },
    [modifyHurdleRate.fulfilled]: (
      state,
      { payload: { status, message, statusCode } }
    ) => {
      state.loading = false;
      if (statusCode === 201) {
        customSuccessAlert(message);
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [modifyHurdleRate.rejected]: (state) => {
      state.loading = false;
    },

    [addStrategies.pending]: (state) => {
      state.loading = true;
    },
    [addStrategies.fulfilled]: (
      state,
      { payload: { statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode == 201) {
        customSuccessAlert(message);
        state.statusCode = statusCode;
        state.message = message;
      } else {
        customFailAlert(message);
        state.statusCode = statusCode;
        state.message = message;
      }
    },
    [addStrategies.rejected]: (state, action) => {
      customFailAlert(action?.error?.message);
      state.loading = false;
    },
    [modifyStrategies.pending]: (state) => {
      state.loading = true;
    },

    [modifyStrategies.fulfilled]: (
      state,
      { payload: { statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        customSuccessAlert(message);
        state.message = message;
        state.statusCode = statusCode;
      } else {
        customFailAlert(message);
        state.message = message;
        state.statusCode = statusCode;
      }
    },
    [modifyStrategies.rejected]: (state, action) => {
      customFailAlert(action?.error?.message);
      state.loading = false;
    },

    [getCustodians.pending]: (state) => {
      state.loading = true;
    },
    [getCustodians.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.error = null;

        state.Custodians = data || "";
      } else {
        state.Custodians = [];
        state.error = message;
        state.status = status;
      }
    },

    [getCustodians.rejected]: (state) => {
      state.loading = false;
    },
    [getCustodianAssets.pending]: (state) => {
      state.loading = true;
    },
    [getCustodianAssets.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        data?.sort((a, b) => a?.symbol.localeCompare(b?.symbol));
        state.custodianAssets = data;
        state.message = message;
        state.code = statusCode;
      } else {
        state.custodianAssets = [];
        state.error = message;
        state.code = statusCode;
      }
    },
    [getCustodianAssets.rejected]: (state) => {
      state.loading = false;
    },

    [getAssets.pending]: (state) => {
      state.loading = true;
    },

    [getAssets.fulfilled]: (
      state,
      { payload: { status, data, code, message } }
    ) => {
      state.loading = false;
      if (code === 200) {
        state.Assets = data;
        state.message = message;
        state.status = status;
      } else {
        state.Assets = {};
        state.error = message;
        state.status = status;
      }
    },
    [getAssets.rejected]: (state) => {
      state.loading = false;
    },
    [GetAccounting.pending]: (state) => {
      state.loading = true;
    },
    [GetAccounting.fulfilled]: (
      state,
      { payload: { statusCode, data, code, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.Accountingdata = data;
        state.message = message;
        state.status = statusCode;
      } else {
        state.Accountingdata = {};
        state.error = message;
        state.status = statusCode;
      }
    },

    [GetAccountingPortfolio.pending]: (state) => {
      state.loading = true;
    },
    [GetAccountingPortfolio.fulfilled]: (
      state,
      { payload: { statusCode, data, code, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.AccountingPortfolio = data;
        state.AccountingPortfolioData = data; // Also store as AccountingPortfolioData for compatibility
        state.message = message;
        state.status = statusCode;
      } else {
        state.Accountingdata = {};
        state.AccountingPortfolioData = {};
        state.error = message;
        state.status = statusCode;
      }
    },
    [GetAccountingPortfolio.rejected]: (state) => {
      state.loading = false;
      state.AccountingPortfolioData = {};
    },


    [Strategyperformancegraph.rejected]: (state) => {
      state.loading = false;
    },

    [GetAccounting.pending]: (state) => {
      state.loading = true;
    },
    [Strategyperformancegraph.fulfilled]: (
      state,
      { payload: { status, data, code, message } }
    ) => {
      state.loading = false;
      if (code === 200) {
        state.strategygraph = data;
        state.message = message;
        state.status = status;
      } else {
        state.strategygraph = [];
        state.error = message;
        state.status = status;
      }
    },
    [Strategyperformancegraph.rejected]: (state) => {
      state.loading = false;
    },

    [AlluserStrategies.fulfilled]: (
      state,
      { payload: { status, data, code, message } }
    ) => {
      state.loading = false;
      if (code === 200) {
        state.userStrategies = data?.userStrategyResponseDtoList;
        state.message = message;
        state.status = status;
      } else {
        state.userStrategies = [];
        state.error = message;
        state.status = status;
      }
    },
    [AlluserStrategies.rejected]: (state) => {
      state.loading = false;
    },

    [AddAccountingFirm.pending]: (state) => {
      state.loading = true;
    },
    [AddAccountingFirm.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200 || statusCode === 201) {
        state.accountingFirms = [...state.accountingFirms, data];
        state.message = message;
        state.code = statusCode;
      } else {
        state.error = message;
        state.code = statusCode;
        if (statusCode !== 409) {
          customFailAlert(message);
        }
        // Do NOT show failed error modal for 409
      }
    },
    [AddAccountingFirm.rejected]: (state) => {
      state.loading = false;
      customFailAlert("Failed to add accounting firm");
    },

    [GetAccountingFirms.pending]: (state) => {
      state.loading = true;
    },
    [GetAccountingFirms.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.accountingFirms = data;
        state.message = message;
        state.code = statusCode;
      } else {
        state.accountingFirms = [];
        state.error = message;
        state.code = statusCode;
      }
    },
    [GetAccountingFirms.rejected]: (state) => {
      state.loading = false;
    },

    [UpdateAccountingFirm.pending]: (state) => {
      state.loading = true;
    },
    [UpdateAccountingFirm.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.accountingFirms = state.accountingFirms.map(firm => 
          firm.id === data.id ? data : firm
        );
        state.message = message;
        state.code = statusCode;
        customSuccessAlert("Accounting firm updated successfully");
      } else {
        state.error = message;
        state.code = statusCode;
        customFailAlert(message);
      }
    },
    [UpdateAccountingFirm.rejected]: (state) => {
      state.loading = false;
      customFailAlert("Failed to update accounting firm");
    },

    [DeleteAccountingFirm.pending]: (state) => {
      state.loading = true;
    },
    [DeleteAccountingFirm.fulfilled]: (
      state,
      { payload: { status, data, statusCode, message } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.accountingFirms = state.accountingFirms.filter(firm => 
          firm.id !== data.id
        );
        state.message = message;
        state.code = statusCode;
        customSuccessAlert("Accounting firm deleted successfully");
      } else {
        state.error = message;
        state.code = statusCode;
        customFailAlert(message);
      }
    },
    [DeleteAccountingFirm.rejected]: (state) => {
      state.loading = false;
      customFailAlert("Failed to delete accounting firm");
    },
    // Get all investors with strategies
    [getAllInvestorsWithStrategies.pending]: (state) => {
      state.loading = true;
    },
    [getAllInvestorsWithStrategies.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.strategiesWithInvestors = data || [];
        state.message = message;
        state.code = statusCode;
      } else {
        state.error = message;
        state.code = statusCode;
      }
    },
    [getAllInvestorsWithStrategies.rejected]: (state) => {
      state.loading = false;
      state.error = "Failed to fetch strategies with investors";
    },
  },
});

export default strategyReducer.reducer;
